export const AUTH_PREFIX = 'Bearer ';
export const JSON_CONTENT_TYPE = 'application/json';
export const BLOB_CONTENT_TYPE = 'blob';
